export const Types = {
  SET_RECORD: 'SET_RECORD',
  SAVE_LIST_BRAND : 'SAVE_LIST_BRAND',
}
